<script>
  import { getRelationshipIcon, getRelationshipColor, getRelationshipLabel } from './statuses.js';
  
  export let relationship = null;
  export let variant = '';
  
</script>

<style>
  .legend-item {
    break-inside: avoid;
    overflow: hidden;
  }
  .cell {
    box-sizing: border-box;
    display: block;
    border-radius: 4px;
    margin: 0.5rem;
    height: 30px;
    width: 30px;
    flex: 0 0 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cell svg {
    height: 12px;
    width: auto;
    transform: scaleX(-1);
  }
  .legend-item {
    display: flex;
    align-items: center;
  }
  label {
    font-size: 12px;
    letter-spacing: .5px;
  }

  .big {
    margin-bottom: 1em;
  }
  .big .cell {
    height: 60px;
    width: 60px;
    flex: 0 0 60px;
    margin: 0 0 0 1rem;
  }
  .big .cell svg {
    height: 20px;
    width: auto;
  }

  .big label {
    font-size: 16px;
  }

  .hide-label label {
    display: none;
  }
</style>

<div class="legend-item {variant}">
  <div class="cell {getRelationshipColor(relationship)}">
    <span class="visually-hidden">{getRelationshipLabel(relationship)}</span>
    {#if getRelationshipIcon(relationship)}
    <svg xmlns="http://www.w3.org/2000/svg">
      <use href="{getRelationshipIcon(relationship)}"/>
    </svg>
    {/if}
  </div>
  <label>{getRelationshipLabel(relationship)}</label>
</div>